<cue-declarative-map-layer
  pane="resource"
  [fill]="childAreaId() !== undefined"
  [interactive]="true"
  (click)="click.emit()"
  [radius]="radius()"
  [weight]="0"
  [fillOpacity]="fillOpacity()"
  [fillColor]="fillColor()"
  [color]="color()"
  [geoJson]="geoJson()"
/>
